import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router-dom";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import Home from "./pages/home/Home";
import Services from "./pages/services/Services";
import Layout from "./components/Layout";
import Blog from "./pages/blog/Blog";
import Faqs from "./pages/faqs/Faqs";
import BlogDetails from "./pages/blogDetails/BlogDetails";
import WebDesign from "./pages/individualService/webDesign/WebDesign";
import Seo from "./pages/individualService/SEO/Seo";
import VideoEditing from "./pages/individualService/videoEditing/VideoEditing";
import ContectCreation from "./pages/individualService/contectCreation/ContectCreation";
import GraphicDesign from "./pages/individualService/graphicDesign/GraphicDesign";
import SocialMedia from "./pages/individualService/socialMedia/SocialMedia";
import MotionGraphic from "./pages/individualService/motionGraphic/MotionGraphic";
import MediaAds from "./pages/individualService/mediaAds/MediaAds";
import CreativeBundle from "./pages/individualService/creativeDesignBundle/CreativeBundle";
import WorkWithUs from "./pages/workWithUs/WorkWithUs";

const routes = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route path="webDesign" element={<WebDesign />} />
        <Route path="seo" element={<Seo />} />
        <Route path="videoEditing" element={<VideoEditing />} />
        <Route path="contectCreation" element={<ContectCreation />} />
        <Route path="graphicDesign" element={<GraphicDesign />} />
        <Route path="socialMedia" element={<SocialMedia />} />
        <Route path="motionGraphic" element={<MotionGraphic />} />
        <Route path="mediaAds" element={<MediaAds />} />
        <Route path="creativeBundle" element={<CreativeBundle />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:id" element={<BlogDetails />} />
        <Route path="work" element={<WorkWithUs />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
      </Route>
    </>
  )
);

function App() {
  return (
    <div className="app">
      <RouterProvider router={routes} />
    </div>
  );
}

export default App;
